import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Disclosure, Transition } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';

import LogoWhite from 'img/logo_white.png';
import ExchangeLogoWhite from 'img/exchange.logo_white.png';
import { ReactComponent as InstagramIcon } from 'img/icons/instagram.svg';
import { ReactComponent as FacebookIcon } from 'img/icons/facebook.svg';
import YoutubeIcon from 'img/icons/youtube.png';

import { classNames } from 'utils/functions';
import StorageService from 'utils/storage';
import { useAuth } from 'contexts/Auth';

export default function LandingHeader() {
  const history = useNavigate();
  const auth = useAuth();

  const navigation = StorageService.get('userData')?.full_name
    ? [
        { name: 'Blog', href: '#' },
        { name: 'Operaciones', href: '/my_operations' },
      ]
    : [{ name: 'Blog', href: '#' }];

  return (
    <Disclosure as="nav" className="fixed z-20 w-full bg-gray-800/90 sm:relative sm:bg-transparent">
      {({ open }) => (
        <>
          <div className="relative flex items-center justify-between p-6 sm:space-x-4 sm:px-12 sm:py-8">
            <img
              src={process.env.REACT_APP_LOGO === 'exchange' ? ExchangeLogoWhite : LogoWhite}
              className="xs:h-20 h-16 md:h-24"
              alt=""
            />
            <div className="hidden flex-col items-end space-y-4 sm:flex">
              <div className="flex space-x-4">
                <p className="flex h-8 w-8 items-center justify-center rounded-full bg-white">
                  <InstagramIcon className="h-4.5 w-4.5" />
                </p>
                <p className="flex h-8 w-8 items-center justify-center rounded-full bg-white">
                  <FacebookIcon className="h-5 w-5" />
                </p>
                <img src={YoutubeIcon} className="h-8" alt="" />
              </div>
              <div className="flex items-center space-x-6 text-white">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-lg hover:text-primary-300 hover:underline"
                  >
                    {item.name}
                  </Link>
                ))}
                {StorageService.get('userData')?.full_name && (
                  <p className="text-lg">Hola! {StorageService.get('userData')?.full_name}</p>
                )}
                {StorageService.get('userData')?.full_name ? (
                  <button
                    onClick={() => auth.signout(() => history('/', { replace: true }))}
                    className="rounded-lg bg-primary-600 px-12 py-2 text-white transition-colors hover:bg-primary-700"
                  >
                    Salir
                  </button>
                ) : (
                  <>
                    <Link to="/login">
                      <button className="rounded-lg bg-primary-600 px-12 py-2 text-white transition-colors hover:bg-primary-700">
                        Iniciar sesión
                      </button>
                    </Link>
                  </>
                )}
              </div>
            </div>
            <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-200 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white sm:hidden">
              <span className="sr-only">Open main menu</span>
              {open ? (
                <XIcon className="block h-8 w-8" aria-hidden="true" />
              ) : (
                <MenuIcon className="block h-8 w-8" aria-hidden="true" />
              )}
            </Disclosure.Button>
          </div>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="sm:hidden">
              <div className="space-y-1 px-2 pt-2 pb-3">
                {navigation.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as={Link}
                    to={item.href}
                    className={classNames(
                      false
                        ? 'bg-primary-500 text-gray-800'
                        : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                      'block rounded-md px-3 py-2 text-base font-medium'
                    )}
                    aria-current={false ? 'page' : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
